import { ORGANIZATION_TAB } from './organizationPrograms';

export enum CHURCH_ADMIN_PROGRAM {
  MPA = 'mpa',
  CAMINO = 'camino',
  MESSAGES = 'messages',
  MIO = 'mio',
  MINISTRY_SCHEDULER = 'mp_ministries',
  ADORATION = 'adoration',
  FORMS = 'forms',
}

export enum SUPER_ADMIN_SORT_BY {
  NAME = 'first_name',
  EMAIL = 'email',
}

export const ADMIN_PROGRAM_LABELS: Record<CHURCH_ADMIN_PROGRAM, string> = {
  [CHURCH_ADMIN_PROGRAM.MPA]: 'MyParish (MPA)',
  [CHURCH_ADMIN_PROGRAM.CAMINO]: 'Camino',
  [CHURCH_ADMIN_PROGRAM.MESSAGES]: 'Messages',
  [CHURCH_ADMIN_PROGRAM.MIO]: 'MIO',
  [CHURCH_ADMIN_PROGRAM.MINISTRY_SCHEDULER]: 'Ministry Scheduler',
  [CHURCH_ADMIN_PROGRAM.ADORATION]: 'Adoration',
  [CHURCH_ADMIN_PROGRAM.FORMS]: 'Forms',
};

export const TAB_TO_PROGRAM: Partial<Record<ORGANIZATION_TAB, CHURCH_ADMIN_PROGRAM>> = {
  [ORGANIZATION_TAB.MPA]: CHURCH_ADMIN_PROGRAM.MPA,
  [ORGANIZATION_TAB.MINISTRY_SCHEDULER]: CHURCH_ADMIN_PROGRAM.MINISTRY_SCHEDULER,
  [ORGANIZATION_TAB.MASS_INTENTIONS]: CHURCH_ADMIN_PROGRAM.MIO,
  [ORGANIZATION_TAB.ADORATION]: CHURCH_ADMIN_PROGRAM.ADORATION,
  [ORGANIZATION_TAB.CAMINO]: CHURCH_ADMIN_PROGRAM.CAMINO,
  [ORGANIZATION_TAB.MESSAGING]: CHURCH_ADMIN_PROGRAM.MESSAGES,
  [ORGANIZATION_TAB.FORMS]: CHURCH_ADMIN_PROGRAM.FORMS,
};

export type ChurchAdmin = {
  userId: string;
  ssoUserId: string | null;
  email: string;
  firstName: string;
  lastName: string;
  canBeImpersonated: boolean;
  programs: CHURCH_ADMIN_PROGRAM[];
};

export type ChurchAdminSearchItem = {
  userId: string | null;
  ssoUserId: string | null;
  email: string;
  firstName: string;
  lastName: string;
};

export type ChurchAdminCreateRequest = {
  email: string;
  firstName: string;
  lastName: string;
  programs: CHURCH_ADMIN_PROGRAM[];
  ssoUserId: string | null;
};

export type ChurchAdminUpdateRequest = Omit<ChurchAdminCreateRequest, 'ssoUserId'>;

export enum GROUP_LIST_ADMIN_SORT_BY {
  NAME = 'name',
  EMAIL = 'email',
}

export type GroupListAdminScopeItem = {
  id: string;
  name: string;
};

export type ChurchGroupListAdmin = {
  userId: string;
  ssoUserId: string | null;
  email: string;
  firstName: string;
  lastName: string;
  groups: GroupListAdminScopeItem[];
  lists: GroupListAdminScopeItem[];
};

export type SuperAdminUser = {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string | null;
  mobilePhone: string | null;
};

export type SuperAdminCreateRequest = {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber?: string | null;
};

export type SuperAdminListResponse = {
  items: SuperAdminUser[];
  limit: number;
  total: number;
};
